import "./loading-spinner.css";

const LoadingSpinner = () => {
  return (
    <div className="loader">
      <span className="rotate" style={{ "--r": "0" }}></span>
      <span className="rotate" style={{ "--r": "1" }}></span>
      <span className="rotate" style={{ "--r": "2" }}></span>
      <span className="rotate" style={{ "--r": "3" }}></span>
      <span className="rotate" style={{ "--r": "4" }}></span>
    </div>
  );
};

export default LoadingSpinner;
